import { z } from "zod/v4";

import { AgencyCustomerDtoSchema } from "../../../dtos/agency-customers";

export const GetAllAgencyCustomersByAgencyIdRequestPathParamSchema = z.object({
  agencyId: z.uuid(),
});

export type GetAllAgencyCustomersByAgencyIdRequestPathParamType = z.infer<
  typeof GetAllAgencyCustomersByAgencyIdRequestPathParamSchema
>;

export const GetAllAgencyCustomersByAgencyIdResponseBodySchema = z.object({
  customers: AgencyCustomerDtoSchema.array(),
});

export type GetAllAgencyCustomersByAgencyIdResponseBodyType = z.infer<
  typeof GetAllAgencyCustomersByAgencyIdResponseBodySchema
>;
